<template>
  <div class="version">
    <v-btn
      v-if="appVersion !== null"
      variant="plain"
      class="cr-btn"
      @click="openDialog()"
    >
      &copy; asfal s.r.o.
    </v-btn>
    <v-btn
      v-else
      variant="plain"
      class="cr-btn"
      href="https://asfal.eu"
      target="_blank"
    >
      &copy; asfal s.r.o.
    </v-btn>
  </div>
  <v-dialog
    v-if="appVersion !== null"
    v-model="dialog"
    class="versionDialog"
    persistent
    max-width="800"
  >
    <v-card>
      <v-card-title>{{ t('info.dialogTitle') }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            {{ t('info.copyright') }}
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            <v-btn
              variant="text"
              href="https://asfal.eu"
              target="_blank"
            >
              &copy; asfal s.r.o.
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="mt-4 mb-4" />
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <strong>{{ t('info.backend.title') }}</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            {{ t('info.backend.version') }}
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            {{ appVersion.version }}
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            {{ t('info.backend.commitHash') }}
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            <v-btn
              variant="text"
              @click="copyToClip(appVersion.gitCommit)"
            >
              <v-icon>mdi-content-copy</v-icon> {{ appVersion.gitCommit }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            {{ t('info.backend.buildTime') }}
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            {{ appVersion.buildTime }}
          </v-col>
        </v-row>

        <template
          v-if="
            configData &&
            (configData.quarkusApplicationVersion ||
              configData.buildTimestamp ||
              configData.buildGitCommit)
          "
        >
          <v-divider class="mt-4 mb-4" />
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <strong>{{ t('info.frontend.title') }}</strong>
            </v-col>
          </v-row>
          <v-row v-if="configData && configData.quarkusApplicationVersion">
            <v-col
              cols="12"
              md="4"
            >
              {{ t('info.frontend.quarkusApplicationVersion') }}
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              {{ configData.quarkusApplicationVersion }}
            </v-col>
          </v-row>

          <v-row v-if="configData && configData.buildGitCommit">
            <v-col
              cols="12"
              md="4"
            >
              {{ t('info.frontend.buildGitCommit') }}
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-btn
                variant="text"
                @click="copyToClip(configData.buildGitCommit)"
              >
                <v-icon>mdi-content-copy</v-icon> {{ configData.buildGitCommit }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-if="configData && configData.buildTimestamp">
            <v-col
              cols="12"
              md="4"
            >
              {{ t('info.frontend.buildTimestamp') }}
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              {{ configData.buildTimestamp }}
            </v-col>
          </v-row>
        </template>
      </v-card-text>

      <template #actions>
        <v-spacer />
        <v-btn @click="dialog = false"> OK </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { infoToast } from '@/utils/toastUtils';
  import { useDiagStore } from '@/store/diagStore';
  import { useConfigStore } from '@/store/configStore';

  // Define state
  const dialog = ref(false);
  const diagStore = useDiagStore();
  const configStore = useConfigStore();

  const { t } = useI18n();

  const appVersion = computed(() => diagStore.getAppVersion);
  const configData = computed(() => configStore.configData);

  onMounted(async () => {
    await diagStore.fetchDiagInfo();
    await configStore.fetchConfigData();
  });

  // Methods
  const openDialog = () => {
    if (appVersion.value !== null) {
      dialog.value = true;
    }
  };

  const copyToClip = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      infoToast(t('info.copied', { text }));
    });
  };
</script>

<style scoped lang="scss">
  .version {
    text-align: center;
  }
  .cr-btn {
    color: white !important;
  }
  .versionDialog {
    background-color: white;
  }
</style>
